import React, { type PropsWithChildren } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFooterContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <View style={styles.container}>
      <LinearGradient
        style={styles.gradientContainer}
        pointerEvents="none"
        colors={GRADIENT_COLORS.BACK_LAYER}
      />
      <LinearGradient
        style={styles.gradientContainer}
        pointerEvents="none"
        colors={GRADIENT_COLORS.FRONT_LAYER}
      />

      {children}
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GRADIENT_COLORS = {
  BACK_LAYER: [
    theme.colors.OPACITY.BLACK.TRANSPARENT,
    theme.colors.OPACITY.BLACK.LIGHTEST,
  ] as const,
  FRONT_LAYER: [
    theme.colors.OPACITY.OATMEAL.TRANSPARENT,
    theme.colors.OPACITY.OATMEAL.DARKER,
  ] as const,
};

const GRADIENT_CONTAINER_HEIGHT = 40;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  gradientContainer: {
    position: 'absolute',
    top: -GRADIENT_CONTAINER_HEIGHT,
    right: 0,
    left: 0,
    height: GRADIENT_CONTAINER_HEIGHT,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing['10'],
    backgroundColor: theme.colors.WHITE,
    marginTop: 'auto',
    paddingHorizontal: theme.spacing['10'],
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['8'],
  },
});
